/**
 * Route subtree mounted at `/w/:slug/cards` from `App.tsx` (ENG-36205 §8).
 * Code-split so the card-builder bundle (which pulls in the widget renderer)
 * doesn't bloat the initial dashboard load. Mirrors `tables/routes.tsx`.
 */

import { lazy, Suspense, type ReactElement } from "react";
import { Route } from "react-router";

import { RouteFallback } from "../components/route-fallback";

const CardBuilderPage = lazy(() =>
  import("./pages/CardBuilderPage").then((m) => ({ default: m.CardBuilderPage })),
);

function withSuspense(node: ReactElement): ReactElement {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

export function cardTemplatesRoutes() {
  return <Route path="cards" element={withSuspense(<CardBuilderPage />)} />;
}
